module.exports = {
  COOKIE_CONSENT_LOCAL_STORAGE_KEY: 'com.youtubetranscripts.consent',
}
